// Whether a content image is click-to-enlarge, and the viewport helper the
// drag clamp wants. Split out of App.tsx.

// Whether a content image is click-to-enlarge.
//
// Size gate: natural AREA ≥ MIN_ZOOM_AREA (= 200×200). Area is shape-agnostic, so
// wide/tall screenshots (e.g. a 1200×80 toolbar) qualify while small button/icon
// screenshots don't — a plain "both sides ≥ 200" rule wrongly dropped wide ones.
//
// Per-image override (wins over the size gate) for the cases the heuristic
// mis-calls — authors set a class on the <img> in the article markdown:
//   class="kb-zoom"     → always click-to-enlarge
//   class="kb-no-zoom"  → never click-to-enlarge
const MIN_ZOOM_AREA = 200 * 200; // 40,000 px²

/** The viewport, as drag.ts's clamp() wants it. */
export const viewport = () => ({ width: window.innerWidth, height: window.innerHeight });

export const isZoomable = (img: HTMLImageElement): boolean => {
  if (img.classList.contains("kb-no-zoom")) return false;
  if (img.classList.contains("kb-zoom")) return true;
  return img.naturalWidth * img.naturalHeight >= MIN_ZOOM_AREA;
};
